
import axios from "axios";

export default axios.create({
  baseURL: "https://portal.pharao24.de/",
  headers: {
    "Content-type": "application/json"
  }
});